export default __webpack_public_path__ + "static/superbetter-goal-8306c587c0f653800d0eb508062b731a.webp";